'use strict';

/**
 * angular-segment-analytics Configuration Settings
 * @file segment.config.js
 */

angular.module('client').config(['segmentProvider',
  function (segmentProvider) {
    segmentProvider
      .setAutoload(false)
      .setCondition(function () {
        return true;
      });
  }]);
